export default __webpack_public_path__ + "static/media/check_big.e8eb942a.svg";